import React from "react";

/**
 * Lazy loading wrapper for Google OAuth Provider
 * Just renders children without blocking - Google loading is handled in the button component
 */
function LazyGoogleAuth({ children, clientId }) {
  // Store clientId in window for lazy button to use
  if (typeof window !== 'undefined') {
    window.__GOOGLE_CLIENT_ID__ = clientId;
  }
  
  // Simply render children without any Google provider
  // The button component will handle Google loading on-demand
  return <>{children}</>;
}

export default LazyGoogleAuth;
